import styles from './styles.module.scss';
import { useState, useEffect, useRef, useContext } from 'react';
import axios, { AxiosRequestConfig } from 'axios';
import { Board } from '../../../../../components/Board';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../../../globalFunctions';
import { NavButton } from '../../../../../components/NavButton';
import { MessageContext } from '../../../../../providers/MessageProvider';
import Pergunta from './Pergunta';
import { User } from '../../../../../types';
import ImportGift from '../../../../../components/ImportGift';
import { AlertDialogType } from '../../../../../components/AlertDialog';

const API_BASE = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_title || '';

export const LogicManagerKombatRoute: React.FC = () => {
    const [title, setTitle] = useState('');
    const [q1, setQ1] = useState('');
    const [q2, setQ2] = useState('');
    const [q3, setQ3] = useState('');
    const [q4, setQ4] = useState('');
    const [q5, setQ5] = useState('');
    const [resolucao, setResolucao] = useState('');
    const [materiaId, setMateriaId] = useState<number>(1);
    const [dificuldade, setDificuldade] = useState<number>(1);
    const [image, setImage] = useState<File | null>(null);
    const [correct, setCorrect] = useState<number | null>(1);
    const fileInputRef = useRef<any>();
    const [exerciciosImportados, setExerciciosImportados]: any = useState();
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const [alertDialogProps, setAlertDialogProps] = useState<AlertDialogType>();
    const [openAlert, setOpenAlert] = useState<boolean>(false);

    const [userAuth, setUserAuth] = useState<User>({} as User);

    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${userAuth.id}`,
            Accept: 'application/json'
        }
    };

    const [publications, setPublications] = useState<any[]>([]);
    const [bancos, setBancos] = useState<any[]>([]);
    const [editingId, setEditingId] = useState<number | null>(null);

    // estados de edição
    const [edittitle, setEdittitle] = useState('');
    const [editQ1, setEditQ1] = useState('');
    const [editQ2, setEditQ2] = useState('');
    const [editQ3, setEditQ3] = useState('');
    const [editQ4, setEditQ4] = useState('');
    const [editQ5, setEditQ5] = useState('');
    const [editResolucao, setEditResolucao] = useState('');
    const [editMateriaId, setEditMateriaId] = useState<number>(1);
    const [editDificuldade, setEditDificuldade] = useState<number>(1);
    const [editImage, setEditImage] = useState<File | null>(null);
    const [editCorrect, setEditCorrect] = useState<number | null>(null);

    const navigate = useNavigate();

    useEffect(() => {
        verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );
        fetchPublications();
    }, [navigate]);

    const fetchPublications = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/api/perguntas`, requestConfig);
            setPublications(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Erro ao buscar publicações:', error);
        }
        try {
            const { data } = await axios.get(`${API_BASE}/api/bancos`, requestConfig);
            setBancos(Array.isArray(data) ? data : []);
            setMateriaId(data[0].id)
        } catch (error) {
            console.error('Erro ao buscar Bancos:', error);
        }
    };

    const resetForm = () => {
        setTitle('');
        setQ1('');
        setQ2('');
        setQ3('');
        setQ4('');
        setDificuldade(1);
        setResolucao('');
        setQ5('');
        setMateriaId(1);
        setImage(null);
        setCorrect(null);
        cancelEdit();
    };

    const parseGift = (text: string) => {
        const blocks = text.split(/\r?\n\r?\n/).filter(b => b.trim());
        let id = 2;

        const findUnescaped = (str: string, char: string, from = 0) => {
            for (let i = from; i < str.length; i++) {
                if (str[i] === char) {
                    let j = i - 1,
                        bs = 0;
                    while (j >= 0 && str[j] === '\\') {
                        bs++;
                        j--;
                    }
                    if (bs % 2 === 0) return i;
                }
            }
            return -1;
        };

        const unescapeText = (s: string) => {
            return s
                .replace(/\\\{/g, '{')
                .replace(/\\\}/g, '}')
                .replace(/\\=/g, '=')
                .replace(/\\~/g, '~')
                .replace(/\\%/g, '%')
                .replace(/\\\\/g, '\\');
        };

        const findMatchingClosingBrace = (str: string, openIdx: number) => {
            let depth = 0;
            for (let i = openIdx; i < str.length; i++) {
                const ch = str[i];
                let j = i - 1,
                    bs = 0;
                while (j >= 0 && str[j] === '\\') {
                    bs++;
                    j--;
                }
                const escaped = bs % 2 === 1;
                if (!escaped) {
                    if (ch === '{') depth++;
                    else if (ch === '}') {
                        depth--;
                        if (depth === 0) return i;
                    }
                }
            }
            return -1;
        };

        // regex para encontrar data URLs base64 (simples, suficiente para nosso caso)
        const dataUrlRe = /data:[^;]+;base64,[A-Za-z0-9+/=]+/g;

        return blocks.map((block, idx) => {
            id++;

            const titleMatch = block.match(/^::(.*?)::/);
            const title = titleMatch ? titleMatch[1].trim() : `Pergunta ${idx + 1}`;

            const openIdx = findUnescaped(block, '{');
            let questionText = '';
            let inside = '';

            if (openIdx === -1) {
                questionText = block.replace(/^::.*?::/, '').trim();
                inside = '';
            } else {
                const closeIdx = findMatchingClosingBrace(block, openIdx);
                if (closeIdx === -1) inside = block.slice(openIdx + 1);
                else inside = block.slice(openIdx + 1, closeIdx);
                questionText = block
                    .slice(0, openIdx)
                    .replace(/^::.*?::/, '')
                    .trim();
            }

            // --- Mask data URLs to avoid quebras por '=' não-escapados ---
            const dataUrls: string[] = [];
            const maskedInside = inside.replace(dataUrlRe, match => {
                const key = `__DATAURL_${dataUrls.length}__`;
                dataUrls.push(match);
                return key;
            });

            // separar alternativas no maskedInside
            const rawOptions: string[] = [];
            let cur = '';
            for (let i = 0; i < maskedInside.length; i++) {
                const ch = maskedInside[i];
                if (ch === '=' || ch === '~') {
                    let j = i - 1,
                        bs = 0;
                    while (j >= 0 && maskedInside[j] === '\\') {
                        bs++;
                        j--;
                    }
                    if (bs % 2 === 0) {
                        if (cur.length > 0 && cur.trim().length > 0) rawOptions.push(cur);
                        cur = ch; // inicia novo token com o marcador
                        continue;
                    }
                }
                cur += ch;
            }
            if (cur.length > 0 && cur.trim().length > 0) rawOptions.push(cur);

            // restaura data URLs dentro de cada raw option antes do unescape
            const restoreDataUrls = (s: string) => {
                let res = s;
                dataUrls.forEach((d, i) => {
                    res = res.replace(`__DATAURL_${i}__`, d);
                });
                return res;
            };

            const options = rawOptions.map(raw => {
                let correct = false;
                let optText = raw;

                if (optText.startsWith('=')) {
                    correct = true;
                    optText = optText.slice(1);
                } else if (optText.startsWith('~%')) {
                    const m = optText.match(/^~%(\-?\d+)%/);
                    if (m) {
                        const weight = parseInt(m[1], 10);
                        optText = optText.slice(m[0].length);
                        correct = weight > 0;
                    } else {
                        optText = optText.slice(1);
                    }
                } else if (optText.startsWith('~')) {
                    correct = false;
                    optText = optText.slice(1);
                }

                // restaura data urls antes de des-escapar
                optText = restoreDataUrls(optText);

                optText = unescapeText(optText.trim());

                return {
                    id: id++,
                    text: optText,
                    dropAreas: [correct ? 'dropbox' : 'lixeira'],
                    name: 'dragbox',
                    type: 'alternativa',
                    css: {
                        backgroundColor: '#54ba5e',
                        color: '#000',
                        borderStyle: 'none',
                        borderColor: '#fff',
                        WebkitTextStrokeWidth: '0px',
                        fontSize: '100%'
                    },
                    width: 0.054146970348087665,
                    height: 0.14434180138568128,
                    pos: { x: 0, y: 0 },
                    scale: 1,
                    imagem: 'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca.gif',
                    borderStyle: 'none'
                };
            });

            return {
                title,
                description: questionText,
                json: {
                    dropAreas: [
                        {
                            id: 1,
                            name: 'lixeira',
                            type: 'trash',
                            pos: { x: 0.37, y: 0.3 },
                            dropAreas: [],
                            scale: 1,
                            text: 'Texto',
                            imagem: 'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca.gif',
                            borderStyle: 'none',
                            css: {
                                borderStyle: 'none',
                                color: '#000',
                                borderColor: 'black',
                                transform: 'scale(1)'
                            },
                            width: 100,
                            height: 100
                        },
                        {
                            id: 2,
                            name: 'dropbox',
                            type: 'dropBox',
                            pos: { x: 0.15, y: 0.25 },
                            bgColor: '#fff',
                            scale: 1,
                            text: 'Coloque aqui a alternativa correta',
                            multiple: true,
                            css: {
                                borderWidth: '3.3px',
                                borderStyle: 'solid',
                                borderColor: '#1eff00',
                                backgroundColor: '#dfffdb',
                                borderRadius: '6.5%',
                                color: '#000000',
                                fontFamily: 'Tahoma, Geneva, sans-serif'
                            },
                            width: 0.1903367496339678,
                            height: 0.1902587519025875,
                            dropAreas: [],
                            imagem: 'https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca.gif',
                            borderStyle: 'none'
                        }
                    ],
                    steps: options
                }
            };
        });
    };

    const handleGiftUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            const giftText = reader.result as string;
            const parsed = parseGift(giftText);
            setExerciciosImportados(parsed);

            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        };
        reader.readAsText(file, 'UTF-8');
    };

    const adicionarPublicacao = async () => {
        try {
            const formData = new FormData();
            formData.append('title', title);
            formData.append('MateriaId', materiaId.toString());
            formData.append('q1', q1);
            formData.append('q2', q2);
            formData.append('q3', q3);
            formData.append('q4', q4);
            formData.append('q5', q5);
            formData.append('resolucao', resolucao);
            formData.append('dificuldade', dificuldade.toString());

            if (correct) formData.append('correct', correct.toString());
            if (image) formData.append('image', image);

            await axios.post(`${API_BASE}/api/perguntas`, formData, requestConfig);

            resetForm();
            fetchPublications();
        } catch (error) {
            console.error('Erro ao adicionar publicação:', error);
        }
    };

    const editarPublicacao = (pub: any) => {
        setEditingId(pub.id ?? null);
        setEdittitle(pub.title ?? '');
        setEditMateriaId(pub.MateriaId ?? 0);
        setEditQ1(pub.q1 ?? '');
        setEditQ2(pub.q2 ?? '');
        setEditQ3(pub.q3 ?? '');
        setEditQ4(pub.q4 ?? '');
        setEditQ5(pub.q5 ?? '');
        setEditCorrect(pub.correct ?? null);
        setEditDificuldade(pub.dificuldade ?? 1);
        setEditResolucao(pub.resolucao ?? '');
        setEditImage(null);
    };

    const submitEdit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (editingId === null) return;
        try {
            const formData = {
                q1: editQ1,
                q2: editQ2,
                q3: editQ3,
                q4: editQ4,
                q5: editQ5,
                title: edittitle,
                MateriaId: editMateriaId.toString(),
                correct: editCorrect,
                resolucao: editResolucao,
                dificuldade: editDificuldade
            };

            await axios.put(`${API_BASE}/api/perguntas/${editingId}`, formData, requestConfig);

            resetForm();
            fetchPublications();
        } catch (error) {
            console.error('Erro ao editar publicação:', error);
        }
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEdittitle('');
        setEditQ1('');
        setEditQ2('');
        setEditQ3('');
        setEditQ4('');
        setEditQ5('');
        setEditDificuldade(1);
        setEditResolucao('');
        setEditMateriaId(0);
        setEditImage(null);
        setEditCorrect(null);
    };

    const deletarPublicacao = async (id: number) => {
        try {
            await axios.delete(`${API_BASE}/api/perguntas/${id}`, requestConfig);
            setPublications(prev => prev.filter(p => p.id !== id));
        } catch (error) {
            console.error('Erro ao deletar publicação:', error);
        }
    };

    const importExercisesBatch = async () => {
        if (!exerciciosImportados) return;

        const questions = exerciciosImportados
            .filter(ex => ex.json && ex.json.steps.length > 0)
            .map(ex => {
                const correctIndex = ex.json.steps.findIndex(step =>
                    step.dropAreas.includes('dropbox')
                );
                return {
                    title: ex.description || 'Sem título',
                    MateriaId: materiaId,
                    q1: ex.json.steps[0]?.text || '',
                    q2: ex.json.steps[1]?.text || '',
                    q3: ex.json.steps[2]?.text || '',
                    q4: ex.json.steps[3]?.text || '',
                    q5: ex.json.steps[4]?.text || '',
                    correct: correctIndex !== -1 ? correctIndex + 1 : null,
                    resolucao: 'Bom dia',
                    dificuldade
                };
            });
        setExerciciosImportados(undefined);

        try {
            await axios.post(`${API_BASE}/api/perguntas/batch`, { questions }, requestConfig);
            setOpenMessage(true);
            setMessage({
                type: 'success',
                content: `${questions.length} perguntas importadas com sucesso`
            });
            await fetchPublications();
        } catch (err) {
            console.error(err);
            setMessage({ type: 'error', content: 'Erro ao importar perguntas em massa' });
        }
    };

    const goBackwards = () => navigate('/manager');

    return (
        <div className={styles.wrapper}>
            <Board wrapperClass={styles.board}>
                <div className={styles.container}>
                    <h1 className={styles.titulo}>Gerenciamento de Perguntas</h1>
                    <label
                        style={{
                            padding: '0.5rem 1rem',
                            background: '#28a745',
                            color: 'white',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            left: '5vw'
                        }}
                    >
                        Importar banco de questões
                        <input
                            ref={fileInputRef}
                            type='file'
                            accept='.gift,.txt'
                            onChange={handleGiftUpload}
                            style={{ display: 'none' }}
                        />
                    </label>
                    {exerciciosImportados && (
                        <ImportGift
                            exercicios={exerciciosImportados}
                            onConfirm={importExercisesBatch}
                            onCancel={() => {
                                setExerciciosImportados(undefined);
                            }}
                        />
                    )}

                    <form
                        onSubmit={editingId !== null ? submitEdit : adicionarPublicacao}
                        className={styles.form}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1rem',
                                height: '30vh',
                                padding: '1rem'
                            }}
                        >
                            {/* Enunciado */}
                            <input
                                type='text'
                                placeholder={editingId !== null ? 'Editar Enunciado' : 'Enunciado'}
                                value={editingId !== null ? edittitle : title}
                                onChange={e =>
                                    editingId !== null
                                        ? setEdittitle(e.target.value)
                                        : setTitle(e.target.value)
                                }
                                required
                                style={{
                                    width: '100%',
                                    fontWeight: 'bold',
                                    fontSize: '1.1rem',
                                    padding: '0.5rem'
                                }}
                            />

                            {/* Alternativas */}
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.8rem',
                                    justifyContent: 'flex-start'
                                }}
                            >
                                {[
                                    {
                                        placeholder: 'Alternativa 1',
                                        value: editingId !== null ? editQ1 : q1,
                                        setter: editingId !== null ? setEditQ1 : setQ1
                                    },
                                    {
                                        placeholder: 'Alternativa 2',
                                        value: editingId !== null ? editQ2 : q2,
                                        setter: editingId !== null ? setEditQ2 : setQ2
                                    },
                                    {
                                        placeholder: 'Alternativa 3',
                                        value: editingId !== null ? editQ3 : q3,
                                        setter: editingId !== null ? setEditQ3 : setQ3
                                    },
                                    {
                                        placeholder: 'Alternativa 4',
                                        value: editingId !== null ? editQ4 : q4,
                                        setter: editingId !== null ? setEditQ4 : setQ4
                                    },
                                    {
                                        placeholder: 'Alternativa 5',
                                        value: editingId !== null ? editQ5 : q5,
                                        setter: editingId !== null ? setEditQ5 : setQ5
                                    },
                                    {
                                        placeholder: 'Enunciado',
                                        value: editingId !== null ? editResolucao : resolucao,
                                        setter:
                                            editingId !== null ? setEditResolucao : setResolucao,
                                        ignorar: true
                                    }
                                ].map((field, idx) => {
                                    const optionNumber = idx + 1;
                                    const selectedCorrect =
                                        editingId !== null ? editCorrect : correct;

                                    return (
                                        <div
                                            key={idx}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem'
                                            }}
                                        >
                                            <input
                                                type='text'
                                                placeholder={field.placeholder}
                                                value={field.value}
                                                onChange={e => field.setter(e.target.value)}
                                                required
                                                style={{
                                                    width: '25vw',
                                                    padding: '0.5rem',
                                                    flexGrow: 1,
                                                    minWidth: '150px'
                                                }}
                                            />
                                            {!field.ignorar && (
                                                <>
                                                    <input
                                                        type='radio'
                                                        name='correct'
                                                        checked={selectedCorrect === optionNumber}
                                                        onChange={() =>
                                                            editingId !== null
                                                                ? setEditCorrect(optionNumber)
                                                                : setCorrect(optionNumber)
                                                        }
                                                    />
                                                    <label>Correta</label>
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                                <select
                                    name='banco'
                                    value={editingId !== null ? editMateriaId : materiaId}
                                    onChange={e => {
                                        editingId !== null
                                            ? setEditMateriaId(parseInt(e.target.value))
                                            : setMateriaId(parseInt(e.target.value));
                                    }}
                                >
                                    {bancos.map(banco => (
                                        <option value={banco.id}>{banco.nome}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={styles.actions}>
                                <button
                                    type='submit'
                                    className={editingId !== null ? styles.btnEdit : styles.btnAdd}
                                >
                                    {editingId !== null ? 'Salvar Edição' : 'Adicionar Pergunta'}
                                </button>
                                {editingId !== null && (
                                    <button
                                        type='button'
                                        onClick={cancelEdit}
                                        className={styles.btnCancel}
                                    >
                                        Cancelar
                                    </button>
                                )}
                            </div>
                            <h3 style={{ textAlign: 'center' }}>Questões Cadastradas:</h3>
                            <div className={styles.lista}>
                                {publications.map(pub => (
                                    <div key={pub.id} className={styles.item}>
                                        <Pergunta
                                            p={pub}
                                            deletarMembro={deletarPublicacao}
                                            editar={editarPublicacao}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </form>
                </div>
            </Board>

            <NavButton
                direction='left'
                style={{ left: '0.4vw', top: '2vw', zIndex: '20' }}
                onClick={goBackwards}
            />
        </div>
    );
};
